export default "__VITE_ASSET__CPRhpWPU__"